import React from "react";
import { Button, Checkbox, Popover, Divider, Typography } from "antd";
import { SettingOutlined, ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import type { GridColumnMetadata } from "../../types";

const { Text } = Typography;

interface ColumnSettingsProps {
  columns: GridColumnMetadata[];
  hiddenColumns: string[];
  onToggleColumn: (columnName: string) => void;
  onResetToDefault: () => void;
}

export const ColumnSettings: React.FC<ColumnSettingsProps> = ({
  columns,
  hiddenColumns,
  onToggleColumn,
  onResetToDefault,
}) => {
  const { t } = useTranslation();

  const content = (
    <div style={{ width: 220 }}>
      <div style={{ marginBottom: 8 }}>
        <Text strong>{t("table.columnSettings", "Cài đặt cột")}</Text>
      </div>
      <div
        style={{
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        {columns.map((column) => (
          <div key={column.name} style={{ padding: "4px 0" }}>
            <Checkbox
              checked={!hiddenColumns.includes(column.name)}
              onChange={() => onToggleColumn(column.name)}
            >
              {column.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <Divider style={{ margin: "8px 0" }} />
      <Button
        type="link"
        size="small"
        icon={<ReloadOutlined />}
        onClick={onResetToDefault}
        style={{ padding: 0 }}
      >
        {t("table.resetColumns", "Đặt lại mặc định")}
      </Button>
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomRight">
      <Button icon={<SettingOutlined />} size="small">
        {t("table.columns", "Cột")}
      </Button>
    </Popover>
  );
};

export default ColumnSettings;
